module.exports = __webpack_public_path__ + "static/logo-iziwork-c317c13ae15f08209bb11d0d5bcc952a.png";